import classNames from "classnames";
import scss from "@/styles/pages/pricing/get-a-quote.module.scss";

export const wrapper = classNames(
    // Mobile
    "mobile:p-5",
    "mobile:pb-10",
    // Tablet
    "tablet:p-10",
    // All
    "relative",
    "bg-gray-100",
    // scss["wrapper"],
    "z-0"
);

export const usability = classNames(
    "relative",
    "z-10"
);

export const subheading = classNames(
    // Mobile
    "mobile:text-base",
    // Tablet
    "tablet:text-lg",
    // All
    "mt-5",
    "mb-5",
    "text-center"
);

export const description = classNames(
    // Mobile
    "mobile:text-base",
    // Tablet
    "tablet:text-lg",
    // All
    "mt-5",
    "text-center",
    "font-medium"
);
export const link = classNames("text-primary", "font-bold");

export const privacyText = classNames("mt-5", "max-w-4xl", "m-auto", "text-center");
